import React from "react";
import { Card, Divider, Typography } from "antd";
import DS_OutwaredBin from "../../../../components/DispatchCentre/DS_OutwaredBin/DS_OutwaredBin";
import "../../../../styles/global-ui.css";

const OutwaredBinPage = ({ userData }) => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            Bin Status
          </Typography.Title>
          <Typography.Text className="page-subtitle">
            View dispatch center inward and outward bin movement reports
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <Card className="modern-card">
        <DS_OutwaredBin userData={userData} />
      </Card>
    </div>
  );
};

export default OutwaredBinPage;